import { DefaultSortOrder, DomainNode } from './types';
import { moveSortOrderType } from 'ui/sort-order/constants';
import clone from 'clone';

export function getNotSelectedOptions(
  sortByItem: DefaultSortOrder,
  defaultSortOrder: DefaultSortOrder[],
  sortOptions: DomainNode[]
): DomainNode[] {
  const selected: any = defaultSortOrder
    .map((curr) => curr.domainNode.value)
    .filter((element) => element !== sortByItem.domainNode.value);

  return sortOptions
    .filter((element) => !selected.includes(element.value) ? element : null);
}

export function sortDefaultSortOrder(
  domainNumber: number,
  collection: DefaultSortOrder[],
  type: moveSortOrderType): DefaultSortOrder[] {

  let updated = [];
  const c = clone(collection);
  const current = c.find((element) => element.domainNode.value === domainNumber);
  const prev = c.find((element) => element.orderBySequence === current.orderBySequence - 1);
  const next = c.find((element) => element.orderBySequence === current.orderBySequence + 1);
  
  if (type === moveSortOrderType.UP) {
    current.orderBySequence = current.orderBySequence - 1;
    prev.orderBySequence = prev.orderBySequence + 1;
    updated = [current, prev];    
  } else {
    current.orderBySequence = current.orderBySequence + 1;
    next.orderBySequence = next.orderBySequence - 1;
    updated = [current, next];
  }

  const used = updated.map((item) => item.domainNode.value);
  const rest = c.filter((element) => used.indexOf(element.domainNode.value) === -1 ? element : null);

  return updated.concat(rest);
}
